import { useQuery } from "@tanstack/react-query"
import { getActiveGiftCreditRequests } from "../../../../services/gift-credit"
import auth from "../../../../lib/auth"

const useGiftCreditActiveRequests = () => {
  const query = useQuery({
    enabled: auth?.isLoggedIn,
    queryKey: ["GET_CREDIT_ACTIVE_REQUESTS"],
    queryFn: async () => {
      const { data } = await getActiveGiftCreditRequests()
      return data
    },
    gcTime: 0
  })

  return query
}

export default useGiftCreditActiveRequests
